export const getParam = <T>(name: string): T => {
    console.log(window.location.href);
    const url = new URL(window.location.href);
    return url.searchParams.get(name) as any;
};
